import { AppModal } from "@/components/modals/AppModal/AppModal";
import { useState } from "react";
import { Typography, Button, Box } from "@mui/joy";
import { FormattedMessage } from "react-intl";
import { TConfirmationData } from "./types";
import { toast } from "react-toastify";
import { useIntl } from "react-intl";
import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client";
import { LinkifiedText } from "./helpers/LinkifiedText";

enum PassConfirmationVisit {
  Confirmed = "CONFIRMED",
  NotSure = "NOT_SURE",
  NotComing = "NOT_COMING",
}

const UPDATE_PASS_STATUS_CONFIRMATION_VISIT = gql`
  mutation UpdatePassStatusConfirmationVisit($recId: String!, $status: PassConfirmationVisit!) {
    updatePassStatusConfirmationVisit(recId: $recId, status: $status) {
      recId
      statusConfirmationVisit
    }
  }
`;

export default function ConfirmationVisit({ data }: { data: TConfirmationData }) {
  const intl = useIntl();
  const [openСonfirmationModal, setOpenСonfirmationModal] = useState(true);
  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [messageForModal, setMessageForModal] = useState("");
  const [confirmationStatus, setConfirmationStatus] = useState<PassConfirmationVisit | null>();
  const [updateConfirmationVisit] = useMutation(UPDATE_PASS_STATUS_CONFIRMATION_VISIT);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const messagesMap = {
    [PassConfirmationVisit.Confirmed]: data.confirmTrue,
    [PassConfirmationVisit.NotSure]: data.confirmFalse,
    [PassConfirmationVisit.NotComing]: data.confirmFalse,
  };

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);

    const recId = data.pass;
    const status = confirmationStatus;
    setMessageForModal(confirmationStatus ? messagesMap[confirmationStatus] ?? "" : "");

    try {
      await updateConfirmationVisit({
        variables: {
          recId,
          status,
        },
      });

      setOpenСonfirmationModal(false);
      setOpenMessageModal(true);
    } catch (error) {
      toast.error(intl.formatMessage({ defaultMessage: "Не удалось отправить ответ" }));
    } finally {
      setIsSubmitting(false);
    }
  };

  const currentDate = new Date();
  const lessonDate = new Date(data.date) || new Date();
  const lessonTime = `${String(lessonDate.getUTCHours()).padStart(2, "0")}:${String(
    lessonDate.getUTCMinutes()
  ).padStart(2, "0")}`;

  return (
    <>
      <AppModal open={openСonfirmationModal} onClose={() => setOpenСonfirmationModal(false)}>
        <form onSubmit={onSubmit}>
          <Typography sx={{ paddingBottom: "20px", fontWeight: "bold" }}>
            {data.name}
            <FormattedMessage defaultMessage=", здравствуйте!" />
          </Typography>

          {lessonDate > currentDate ? (
            <>
              <Typography sx={{ paddingBottom: "20px", fontWeight: "bold" }}>
                <FormattedMessage defaultMessage="Это Школа танца и пластики AMANI 💕 Хотим напомнить, что Вы записаны на занятие" />{" "}
                {data.direction} <FormattedMessage defaultMessage="завтра в" /> {lessonTime} {data.branch}
                <FormattedMessage defaultMessage=", Вы придете?" />
              </Typography>

              <Box sx={{ display: "grid", gap: "10px" }}>
                <Button
                  type="submit"
                  sx={{ background: "#1bafa1" }}
                  onClick={() => setConfirmationStatus(PassConfirmationVisit.Confirmed)}
                  disabled={isSubmitting}
                >
                  <FormattedMessage defaultMessage="Помню, приду 💜" />
                </Button>

                <Button
                  type="submit"
                  sx={{ background: "#f8c426", color: "black" }}
                  onClick={() => setConfirmationStatus(PassConfirmationVisit.NotSure)}
                  disabled={isSubmitting}
                >
                  <FormattedMessage defaultMessage="Пока не уверена 🤔" />
                </Button>

                <Button
                  type="submit"
                  sx={{ background: "#d5465b" }}
                  onClick={() => setConfirmationStatus(PassConfirmationVisit.NotComing)}
                  disabled={isSubmitting}
                >
                  <FormattedMessage defaultMessage="Точно не приду 😔" />
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Typography sx={{ paddingBottom: "20px", fontWeight: "bold" }}>
                <FormattedMessage defaultMessage="Это занятие уже прошло. Ждем вас на следующих 💕" />
              </Typography>
            </>
          )}
        </form>
      </AppModal>

      <AppModal open={openMessageModal} onClose={() => setOpenMessageModal(false)}>
        <Box sx={{ whiteSpace: "pre-line", paddingBottom: "20px" }}>
          <LinkifiedText text={messageForModal} />
        </Box>

        <Button sx={{ margin: "auto", display: "block" }} onClick={() => setOpenMessageModal(false)}>
          <FormattedMessage defaultMessage="Закрыть" />
        </Button>
      </AppModal>
    </>
  );
}
